/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { acceptInvitation } from '../fn/profile-invitation/accept-invitation';
import { AcceptInvitation$Params } from '../fn/profile-invitation/accept-invitation';
import { getInvitationStatus } from '../fn/profile-invitation/get-invitation-status';
import { GetInvitationStatus$Params } from '../fn/profile-invitation/get-invitation-status';
import { ProfileInvitationStatusResponse } from '../models/profile-invitation-status-response';

@Injectable({ providedIn: 'root' })
export class ProfileInvitationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getInvitationStatus()` */
  static readonly GetInvitationStatusPath = '/rest/invitation/{hash}';

  /**
   * Get status of invitation of user to profile by hash from invitation email. Public service, frontend uses it to decide if it shows sign up, login or screen for expired / cancelled invitation.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInvitationStatus()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvitationStatus$Response(params: GetInvitationStatus$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileInvitationStatusResponse>> {
    return getInvitationStatus(this.http, this.rootUrl, params, context);
  }

  /**
   * Get status of invitation of user to profile by hash from invitation email. Public service, frontend uses it to decide if it shows sign up, login or screen for expired / cancelled invitation.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInvitationStatus$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInvitationStatus(params: GetInvitationStatus$Params, context?: HttpContext): Observable<ProfileInvitationStatusResponse> {
    return this.getInvitationStatus$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileInvitationStatusResponse>): ProfileInvitationStatusResponse => r.body)
    );
  }

  /** Path part for operation `acceptInvitation()` */
  static readonly AcceptInvitationPath = '/rest/invitation/{hash}/accept';

  /**
   * Accept invitation of user to profile by hash from invitation email. Required is token of user logged in Auth0 with email of invited user. Account of user who just signed up is linked with invited user (hash proves that user owns the email) and his email is marked as verified. Can be called repeatedly. Without accepted invitation all other services return 403 with code EMAIL_NOT_VERIFIED for account with not verified email of invited user.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `acceptInvitation()` instead.
   *
   * This method doesn't expect any request body.
   */
  acceptInvitation$Response(params: AcceptInvitation$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileInvitationStatusResponse>> {
    return acceptInvitation(this.http, this.rootUrl, params, context);
  }

  /**
   * Accept invitation of user to profile by hash from invitation email. Required is token of user logged in Auth0 with email of invited user. Account of user who just signed up is linked with invited user (hash proves that user owns the email) and his email is marked as verified. Can be called repeatedly. Without accepted invitation all other services return 403 with code EMAIL_NOT_VERIFIED for account with not verified email of invited user.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `acceptInvitation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  acceptInvitation(params: AcceptInvitation$Params, context?: HttpContext): Observable<ProfileInvitationStatusResponse> {
    return this.acceptInvitation$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileInvitationStatusResponse>): ProfileInvitationStatusResponse => r.body)
    );
  }

}
